import React, { useState } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import CreateIcon from '@mui/icons-material/Create'
import { useFormik } from 'formik'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import schema from './schema'
import { CollectionFormType, StoryUpdateType } from '../../../../lib/types'

interface iAbout {
  title: string
  id: string
  description: string
  isEditor: boolean
  update: (formData: StoryUpdateType | CollectionFormType) => void
  isPlaying?: boolean
  editMode: boolean
  setEditMode: (editMode: boolean) => void
}

const About: React.FC<iAbout> = ({
  update,
  title,
  id,
  description,
  isEditor,
  children,
  isPlaying,
  editMode,
  setEditMode
}) => {
  const initialValues = { title: title, description: description }

  const onSubmit = async (values: { title: string; description: string }) => {
    try {
      await update({ ...values })
      setEditMode(false)
    } catch (error) {}
  }

  const { isSubmitting, values, handleBlur, handleChange, touched, errors, handleSubmit } = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit
  })

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexFlow: 'column',
        '&>*': {
          margin: '3px 0'
        }
      }}
    >
      <Box
        sx={{
          padding: '0 24px',
          display: isPlaying || editMode ? 'static' : 'none'
        }}
        component={Paper}
      >
        {!editMode && (
          <>
            <Box
              sx={{
                width: '100%',
                display: 'flex'
              }}
            >
              <Typography
                sx={{
                  flex: '1',
                  verticalAlign: 'middle'
                }}
                variant="h5"
              >
                {title}
              </Typography>
            </Box>
            <Typography
              sx={{
                flex: '1',
                opacity: !isPlaying ? '0' : '1'
              }}
              variant="h5"
              paragraph
            >
              {'\t' + description}
            </Typography>
          </>
        )}
        {editMode && (
          <form>
            <Grid container spacing={4} direction="row" justifyContent="center" alignItems="center">
              <Grid item xs={12}>
                <TextField
                  name="title"
                  fullWidth
                  label="Title"
                  value={values.title}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.title && Boolean(errors.title)}
                  helperText={(touched.title && errors.title) || ' '}
                />
                <TextField
                  name="description"
                  fullWidth
                  multiline
                  rows={4}
                  label="Description"
                  value={values.description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.description && Boolean(errors.description)}
                  helperText={(touched.description && errors.description) || ' '}
                />
              </Grid>
              <Grid
                sx={{
                  textAlign: 'end'
                }}
                item
                xs={12}
              >
                <Button onClick={() => setEditMode(false)}>Cancel</Button>
                <Button color={'primary'} disabled={isSubmitting} variant="contained" onClick={() => handleSubmit()}>
                  Save
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Box>
      <Box component={Paper}>{children}</Box>
    </Box>
  )
}

export default About
